import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantsOrders = (id, page = 1, term = null, status = null, type = null) => useQuery({ queryKey: [`${id}-orders`, page, term, status, type], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/orders?page=${page}${term ? `&term=${term}` : ''}${status ? `&status=${status}` : ''}${type ? `&type=${type}` : ''}`)
    return callback?.data
}})

export default useConsultantsOrders